var sentryGlobalJs = (function () {
  return {
    init: init,
  };

  function init() {
    //Check Sentry exists
    var intS = 0,
      eTime = setInterval(function () {
        if (window.hasOwnProperty('Sentry')) {
          uiBindings();
          clearInterval(eTime);
        }
        if (++intS >= 10) {
          clearInterval(eTime);
        }
      }, 100);
  }

  function uiBindings() {
    var DisableSentryEvent = false,
      environmentName = 'staging',
      debugFlag = 'false';
    if (/(^|\.)wpengine\.com$/.test(location.hostname)) {
      DisableSentryEvent = window.location.host.split('.')[0] != 'bsengineering' ? true : false;
    }

    if (window.location.host === 'browserstack.wpengine.com') {
      environmentName = 'production';
      debugFlag = 'false';
    } else if (window.location.host === 'bsengineering.wpengine.com') {
      environmentName = 'bsengineering';
      debugFlag = 'true';
    } else {
      environmentName = 'staging';
      debugFlag = 'false';
    }

    if (typeof sentry_custom_tags !== 'undefined' && Object.keys(sentry_custom_tags).length > 0) {
      Sentry.configureScope(function (scope) {
        // add custom tags params
        Object.keys(sentry_custom_tags).forEach(function (key) {
          scope.setTag(key, sentry_custom_tags[key]);
        });
      });
    }

    Sentry.onLoad(function () {
      Sentry.init({
        environment: environmentName,
        debug: debugFlag,
        ignoreUrls: [
          'https://www.google.com/recaptcha/api.js', // Recaptcha Library Js
          'https://www.gstatic.com/', // Analytics Library Js
          '/dev.visualwebsiteoptimizer.com/', // VWO Js
          'https://static.ads-twitter.com/uwt.js', //  Twitter ads js
          'https://bat.bing.com/bat.js', // Bat pixel added via GTM
          'https://connect.facebook.net/en_US/fbevents.js', // Facebook auth js
          'https://3fxtqy18kygf3on3bu39kh93-wpengine.netdna-ssl.com/wp-content/themes/browserstack/src/js/libraries/amplitude-4.1.1-min.gz.js', // Amplitude Library Js
          '/connect.facebook.net/', // Facebook PIxel Js
          '/youtube.com/', // Youtube Player default js
          'https://static.doubleclick.net/instream/ad_status.js', // Double Click ad js
          '/chrome-extension/', // Any Chrome extension js
          '/m=gis_client_library', // This is mostly from third party Google One Tap JS
          '/gsi/', // Google One Tap JS file regex
          '/_/gsi/_/js/', // Google One Tap JS file regex
          'https://accounts.google.com/gsi/client', // Google One Tap JS
          'https://ws-assets.zoominfo.com/formcomplete.js', // Zoominfo JS
          'https://js.zi-scripts.com/zi-tag.js', // Zoominfo JS
          'https://assets.revsure.cloud/static/global/js/rs-fpsdk.js.gz', // Revsure JS tracking
          'https://analytics.revsure.cloud/', // Revsure JS tracking,
          'https://s3-us-west-2.amazonaws.com/b2bjsstore/b/', // de-anonymization of the visitor Revsure form submit
          'https://api.cr-relay.com', //CommonRoom api
          'https://cdn.cr-relay.com', //CommonRoom cdn
          'https://cdn.cr-relay.com/v1/site/552c90cc-4bf8-4dc4-938d-e59be20e7e8b/signals.js', //CommonRoom track visitor on form submit
          '/signals.js' //CommonRoom track visitor on form submit relative path
        ],
        ignoreErrors: [
          "Cannot read property 'hide' of null",
          "Cannot read property 'length' of undefined",
          'Persistent storage maximum size reached',
          'i is null',
          't is not a function',
          "Cannot set property 'tabindex' of undefined",
          "Can't create RTCPeerConnections when the network is down",
          "Failed to execute 'send' on 'RTCDataChannel': Could not send data",
          "Failed to construct 'RTCPeerConnection': Failed to initialize native PeerConnection.",
          "Failed to construct 'RTCPeerConnection': No PeerConnection handler can be created, perhaps WebRTC is disabled?",
          "Failed to execute 'close' on 'RTCPeerConnection': The RTCPeerConnection's signalingState is 'closed'.",
          "Failed to execute 'addIceCandidate' on 'RTCPeerConnection': The ICE candidate could not be added.",
          'RTCPeerConnection is gone (did you enter Offline mode?)',
          'CSSStyleSheet.cssRules getter: Not allowed to access cross-origin stylesheet', // This error is coming only on firefox browser, and that too on the vwo  script.
          'C', // Error coming from Linux OS and for chrome 79
          "Cannot read property 'getReadModeRender' of undefined", // coming on “Chrome Mobile WebView“ and occurring for just one combination.
          "a[b].target.className.indexOf is not a function. (In 'a[b].target.className.indexOf(Zb)', 'a[b].target.className.indexOf' is undefined)", // It is coming from Google chrome extension Google translate.
          'Maximum call stack size exceeded', // Mostly due to recursive function with a base case that isn't being met. Not from our code.
          'A', // This is mostly from third party Google One Tap JS
          'z', // This is mostly from third party Google One Tap JS
          'B', // This is mostly from third party Google One Tap JS
          'E', // This is mostly from third party Google One Tap JS
          'A network error occurred', // Network Error. Currently no action item for Network errors
          '$ is not defined', // ReferenceError. This error is not expected from our code base coz we dont have jquery.
          'ResizeObserver loop completed with undelivered notifications', // This mostly comes from an JS animations in our case we don't have such any animations hence seems like coming from third party extension.
          "undefined is not an object (evaluating 'document.getElementsByTagName('video')[0].webkitExitFullScreen')", // This error coming from firefox ios devices when user exit from video. Which we don't have any control over it.
          't.offset() is null', // This error coming from VWO third party library.
          'SecurityError: The operation is insecure', // This error coming only from mozila desktop browser and there is no action item.
          'Non-Error exception captured', // These types of error are caused when a rejection is raised with a non-error object, from which we cannot extract much information.
          'Non-Error promise rejection captured', // These types of error are caused when a rejection is raised with a non-error object, from which we cannot extract much information.
          'Failed to fetch', // Recotap API fetch error in chrome
          'NetworkError when attempting to fetch resource.', // Recotap API fetch error in firefox
          'Load failed', // Recotap API fetch error in safari mobile
          'cancelled', // Recotap API fetch error in IOS chrome & safari
        ],
        beforeSend: function (event, hint) {
          var error = hint.originalException;
          console.log(error)
          //Check Autoptimise load event found and disable Sentry event
          if (error && error.name && error.name.match(/Internal File FileLoadException/i)) {
            DisableSentryEvent = true; //disable fileload exception
          } else if (
            error &&
            error.name &&
            (error.name.match(/Third Party FileLoadException/i) || error.name.match(/NetworkError/i))
          ) {
            // Network Error. Currently no action item for Network errors
            return null;
          }
          //check disable sentry event
          if (DisableSentryEvent) {
            return null;
          }
          return event;
        },
      });
    });

    /**
     * Capturing Script file load errors on sentry
     * Disable Sentry if file is not loaded.
     */
    window.addEventListener(
      'error',
      function (e, url) {
        if (typeof Sentry === 'undefined') {
          return;
        }
        var ele,
          eleArray = ['SCRIPT'],
          resourceMap = { SCRIPT: 'JavaScript File' };

        //just accessing event properties can throw an exception in some rare circumstances. see: https://github.com/getsentry/raven-js/issues/838
        try {
          ele = e.target;
        } catch (e) {
          return;
        }
        if (eleArray.indexOf(ele.tagName) != -1) {
          var url = ele.src,
            setExtra,
            error = new Error(resourceMap[ele.tagName] + ': ' + url + ' failed loading.');
          if (
            /visualwebsiteoptimizer/.test(url) ||
            /analytics/.test(url) ||
            /amplitude/.test(url) ||
            /bat.bing.com/.test(url) ||
            /wchat.freshchat.com/.test(url) ||
            /freshworksapi.com/.test(url) ||
            /googletagmanager/.test(url) ||
            /google.com/.test(url) ||
            /zoominfo.com/.test(url) ||
            /revsure.cloud/.test(url) ||
            /zi-scripts.com/.test(url)
          ) {
            error.name = 'Third Party FileLoadException';
            setExtra = 'ThirdParty';
          } else {
            error.name = 'Internal File FileLoadException';
            setExtra = 'InternalFile';
          }
          try {
            /**
             * Disabled file load error on sentry
             * Sentry.captureException(error);
             * Command to enable Sentry
             * Sentry.getCurrentHub().getClient().getOptions().enabled = undefined;
             */
            Sentry.withScope(function (scope) {
              scope.setExtra('FileName', setExtra);
              Sentry.captureException(error);
            });
          } catch (e) {
            Sentry.withScope(function (scope) {
              scope.setExtra('Error Origin', 'Catch Function of File Load');
              Sentry.captureException(e);
            });
          }
        } else if (['LINK'].indexOf(ele.tagName) != -1) {
          //Check CSS  file load issue and show  bstack-load-error-css.
          var intVar = 0,
            handleCSSTimer = setInterval(function () {
              //Added setInterval to check element exists issue then show css. Also solve issue of Sentry 'null is not an object'
              var handleLoadCSS = document.getElementById('bstack-load-error-css');
              if (
                ele.getAttribute('rel') === 'stylesheet' &&
                handleLoadCSS &&
                null != handleLoadCSS.getAttribute('media')
              ) {
                handleLoadCSS.setAttribute('media', 'all');
                clearInterval(handleCSSTimer);
              }
              if (intVar > 5) {
                clearInterval(handleCSSTimer);
              }
              intVar += 1;
            }, 1000);
        }
      },
      true
    );
  }
})();

sentryGlobalJs.init();
